import { Link } from "wouter";
import redHelicopterLogo from "@assets/footer-logo.jpg";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src={redHelicopterLogo} 
                alt="Red Helicopter Logo" 
                className="w-8 h-8"
              />
              <span className="font-bold text-gray-900">Red Helicopter</span>
            </div>
          </div>
          
          <div className="flex gap-6 text-sm text-gray-600">
            <Link href="/privacy" className="hover:text-gray-900 py-2 px-1 min-h-[44px] flex items-center touch-manipulation">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-gray-900 py-2 px-1 min-h-[44px] flex items-center touch-manipulation">Terms of Service</Link>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-600">
            © 2025 Red Helicopter. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}